import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/pages/home/components/Footer';
import { articles } from '@/mocks/articles';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://hoobuy.baby';

export default function ShoppingGuide() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background-50">
      <title>Guia de Compras HoobuySpreadsheet | Tutoriais e Dicas</title>
      <Navbar />

      <main>
        <section className="pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <nav className="text-xs text-foreground-500 mb-6" aria-label="Breadcrumb">
              <a
                href="/"
                onClick={(e) => { e.preventDefault(); navigate('/'); }}
                className="hover:text-primary-500 transition-colors cursor-pointer"
              >
                Início
              </a>
              <span className="mx-2">/</span>
              <span className="text-foreground-400">Guia de Compras</span>
            </nav>

            <span className="inline-block px-4 py-1.5 text-xs font-semibold bg-primary-100 text-primary-700 rounded-full mb-4">
              Central de Aprendizado
            </span>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-4">
              Guia de Compras HoobuySpreadsheet
            </h1>

            <p className="text-sm md:text-base text-foreground-600 max-w-2xl leading-relaxed">
              Tutoriais completos, comparações detalhadas e dicas essenciais para você dominar as compras internacionais da China. Todo conteúdo é original, atualizado e otimizado para ajudar você a economizar.
            </p>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {articles.map((article, idx) => (
                <a
                  key={article.slug}
                  href={`/artigo/${article.slug}`}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/artigo/${article.slug}`);
                  }}
                  className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/50 hover:border-accent-300/50 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 md:h-52 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute top-3 left-3">
                      <span className={`px-2.5 py-1 text-xs font-semibold rounded-full ${
                        idx === 0 ? 'bg-primary-500 text-white' : 'bg-accent-100 text-accent-700'
                      }`}>
                        {idx === 0 ? 'Essencial' : 'Guia'}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mb-4 line-clamp-2 leading-relaxed">
                      {article.summary}
                    </p>
                    <span className="inline-flex items-center gap-1 text-xs font-semibold text-accent-600 group-hover:text-accent-700 transition-colors">
                      Ler artigo
                      <i className="ri-arrow-right-line text-sm"></i>
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-accent-50/30">
          <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
            <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
              Pronto para Começar a Comprar?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8">
              Agora que você já conhece todos os guias, acesse a planilha completa e comece a economizar.
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-primary-500 text-white rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                hoobuy sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="/"
                onClick={(e) => { e.preventDefault(); navigate('/'); }}
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold bg-foreground-900 text-white rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
              >
                <i className="ri-arrow-left-line"></i>
                Voltar ao Início
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'CollectionPage',
            name: 'Guia de Compras HoobuySpreadsheet',
            description: 'Tutoriais completos, comparações detalhadas e dicas essenciais para dominar as compras internacionais da China.',
            url: SITE_URL + '/guia-de-compras',
            mainEntity: {
              '@type': 'ItemList',
              itemListElement: articles.map((a, i) => ({
                '@type': 'ListItem',
                position: i + 1,
                url: SITE_URL + '/artigo/' + a.slug,
                name: a.title,
              })),
            },
          }),
        }}
      />
    </div>
  );
}